import React from 'react';
import { percentString, positionInRange } from '../../utils';
import { round } from 'lodash';
var BoxAndWhiskerDeviationLine = function (_a) {
    var axisMin = _a.axisMin, axisMax = _a.axisMax, standardDeviation = _a.standardDeviation, mean = _a.mean, tooltipId = _a.tooltipId, tooltipValueFormatter = _a.tooltipValueFormatter;
    var lowerStandardDeviation = round(mean - standardDeviation, 1);
    var upperStandardDeviation = round(mean + standardDeviation, 1);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "boxAndWhiskerChart__deviation", style: {
                left: positionInRange(lowerStandardDeviation, axisMin, axisMax),
                width: widthOfDeviationLine(lowerStandardDeviation, mean, axisMin, axisMax)
            }, "data-for": tooltipId, "data-tip": "Standard Deviation: " + tooltipValueFormatter(standardDeviation) + "<br>\u3008" + tooltipValueFormatter(lowerStandardDeviation) + "; " + tooltipValueFormatter(mean) + "\u3009" }),
        React.createElement("div", { className: "boxAndWhiskerChart__deviation", style: {
                left: positionInRange(mean, axisMin, axisMax),
                width: widthOfDeviationLine(mean, upperStandardDeviation, axisMin, axisMax)
            }, "data-for": tooltipId, "data-tip": "Standard Deviation: " + tooltipValueFormatter(standardDeviation) + "<br>\u3008" + tooltipValueFormatter(mean) + "; " + tooltipValueFormatter(upperStandardDeviation) + "\u3009" })));
};
var widthOfDeviationLine = function (valueStart, valueEnd, rangeStart, rangeEnd) {
    var lengthOfRange = rangeEnd - rangeStart;
    var lengthOfIntervalAbs = valueEnd - valueStart;
    return percentString(lengthOfIntervalAbs, lengthOfRange);
};
export default BoxAndWhiskerDeviationLine;
//# sourceMappingURL=BoxAndWhiskerDeviationLine.js.map